define(function (require) {
    'use strict';

    return {
        balance                     : () => import('popovers/balance/view'),
        staff_config                : () => import('popovers/staff_config/view'),
        tel_online_site             : () => import('popovers/tel_online_site/view'),
        tel_online_config           : () => import('popovers/tel_online_config/view'),
        staff_edit_sites            : () => import('popovers/staff_edit_sites/view'),
        tel_settings_audio          : () => import('popovers/tel_settings_audio/view'),
        list_projects               : () => import('popovers/list_projects/view'),
        constructor_checkbox        : () => import('popovers/constructor_checkbox/view'),
        constructor_colorpicker     : () => import('popovers/constructor_colorpicker/view'),
        crater_steps_alert          : () => import('popovers/crater_steps_alert/view'),
        crater_steps_move           : () => import('popovers/crater_steps_move/view'),
        balance_number              : () => import('popovers/balance_number/view'),
        profile_info                : () => import('popovers/profile_info/view'),
        owner                       : () => import('popovers/owner/view'),
        filter                      : () => import('popovers/filter/view'),
        tasks_repeat                : () => import('popovers/tasks_repeat/view'),
        tasks_remind                : () => import('popovers/tasks_remind/view'),
        phone_type                  : () => import('popovers/phone_type/view'),
        email_type                  : () => import('popovers/email_type/view'),
        messanger_type              : () => import('popovers/messanger_type/view'),
        table_show_column           : () => import('popovers/table_show_column/view'),
        table_sort_column           : () => import('popovers/table_sort_column/view'),
        top_settings                : () => import('popovers/top_settings/view'),
        contacts_name               : () => import('popovers/contacts_name/view'),
        contacts_phone              : () => import('popovers/contacts_phone/view'),
        contacts_email              : () => import('popovers/contacts_email/view'),
        contacts_call               : () => import('popovers/contacts_call/view'),
        contacts_search             : () => import('popovers/contacts_search/view'),
        comments_lead               : () => import('popovers/comments_lead/view'),
        table_datetime              : () => import('popovers/table_datetime/view'),
        wysiwyg_editor              : () => import('popovers/wysiwyg_editor/view'),
        tasks_colorpicker           : () => import('popovers/tasks_colorpicker/view'),
        saved_filter_edit           : () => import('popovers/saved_filter_edit/view'),
        payment_category            : () => import('popovers/payment_category/view'),
        payment_purpose             : () => import('popovers/payment_purpose/view'),
        funnel_steps                : () => import('popovers/funnel_steps/view'),
        field_history               : () => import('popovers/field_history/view'),
        funnel_colorpicker          : () => import('popovers/funnel_colorpicker/view'),
        balance_docs                : () => import('popovers/balance_docs/view'),
        leads_categories            : () => import('popovers/leads_categories/view'),
        staff_list                  : () => import('popovers/staff_list/view'),
        leads_contacts              : () => import('popovers/leads_contacts/view'),
        leads_map                   : () => import('popovers/leads_map/view'),
        lead_change_source          : () => import('popovers/lead_change_source/view'),
        funnel_steps_reminder       : () => import('popovers/funnel_steps_reminder/view'),
        // description_of_lead_field   : () => import('popovers/description_of_lead_field/view'),
        calltracking_area_phone     : () => import('popovers/calltracking_area_phone/view'),
        concrete_date               : () => import('popovers/concrete_date/view'),
        dialog_answer               : () => import('popovers/dialog_answer/view'),
        tabs                        : () => import('popovers/tabs/view'),
        simcard_owner               : () => import('popovers/simcard_owner/view'),
        project_select              : () => import('popovers/project_select/view'),
        staff_select                : () => import('popovers/staff_select/view'),
        table_item_settings         : () => import('popovers/table_item_settings/view'),
        sms_edit                    : () => import('popovers/sms_edit/view'),
        edit_deal_tooltip           : () => import('popovers/edit_deal_tooltip/view'),
        recurrent_tooltip           : () => import('popovers/recurrent_tooltip/view'),
        comments                    : () => import('popovers/comments/view'),
        generic                     : () => import('popovers/generic/view'),
        tarif_option_tooltip        : () => import('popovers/tarif_option_tooltip/view'),
        rule_calltracking_confirm   : () => import('popovers/rule_calltracking_confirm/view'),
        audioDownloader             : () => import('popovers/audio-downloader/view'),
        add_sphere                  : () => import('popovers/add_sphere/view'),
        requiredFieldStageSelect    : () => import('popovers/requiredFieldStageSelect/index'),
        displayFieldStageSelect     : () => import('popovers/displayFieldStageSelect/index'),
        phoneSources                : () => import('popovers/phoneSources/index'),
        leadChatFrom                : () => import('popovers/leadChatFrom/index'),
        selectStepsInStaff          : () => import('popovers/selectStepsInStaff/index'),
        leadChatTo                  : () => import('popovers/leadChatTo/index'),

        create: function (name, callback) {
            if (typeof this[name] === 'undefined') {
                throw new Error('Popover with name ' + name + ', not found');
            }

            this[name]().then((popover) => callback(popover.default));
        }
    };
});
